/* eslint-disable no-restricted-imports */
import styled from 'styled-components';
import { Typography } from '../../../ui/typography/Typography';

export const TabText = styled(Typography)
    .withConfig({ displayName: 'TabText' })
    .attrs(() => ({
        color: 'inherit',
        variant: 'body',
        weight: 'medium',
        textAlign: 'center',
    }))``;
